import Page from "../components/page";
import config from "../configs";

const Contact = () => {
  return (
    <Page title={`Contact - ${config.appName}`} hideLoader>
      <div className="info-page">
        <h2 className="text-xl font-bold">Feel Free to Contact Us</h2>
        <p>
          Please feel free to reach out to us for any inquiries. We look forward
          to hearing from you! You can also request new movies or TV series, and
          we will be more than happy to share your favorite content.
        </p>

        <h3 className="text-lg font-semibold mt-4">Contact Information:</h3>
        <p>
          🌐{" "}
          <a
            href={"/"}
            className="text-blue-500 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {config.appName}
          </a>
        </p>
        <p>
          📩 Email:{" "}
          <a
            href={`mailto:${config.email}`}
            className="text-blue-500 hover:underline"
          >
            {config.email}
          </a>
        </p>

        <h3 className="text-lg font-semibold mt-4">Important Note:</h3>
        <p>
          <strong>{config.appName}</strong> is a free movie download site where
          we update content daily. We provide Bollywood, Hollywood movies, and
          web series in **dual audio** and **full HD quality**.
        </p>
        <p>
          Make sure to read and follow our{" "}
          <strong>download instructions</strong> to easily access the latest
          movies and web series.
        </p>
        <p>
          If you find any <strong>broken links</strong> on our site, please
          report them to us. Your feedback is highly appreciated.
        </p>
        <p>
          You can always contact us via <strong>email</strong> or{" "}
          <strong>phone</strong>, and we guarantee a response within **24
          working hours**.
        </p>
        <p>
          📢 <strong>Stay Updated:</strong> Subscribe to our newsletter and
          follow us on all social media platforms for the latest updates!
        </p>
      </div>
    </Page>
  );
};

export default Contact;
